import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core'
import { geniusTheme } from '../../utils/theme'

const ThemePresets = props => {
  const { theme, setTheme } = props
  const { brands } = theme

  // Required to calculate elect label width
  const inputLabel = useRef(null)
  const [labelWidth, setLabelWidth] = useState(0)
  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth)
  }, [])

  const handleChange = event => {
    const selectedBrand = event.target.value
    if (selectedBrand === 'light') {
      setTheme(oldItems => ({
        ...oldItems,
        ...geniusTheme,
        name: 'light',
      }))
    } else {
      setTheme(oldItems => ({
        ...oldItems,
        ...brands[selectedBrand],
        name: selectedBrand,
      }))
    }
  }

  return (
    <Box p={4}>
      <FormControl variant="outlined" style={{ minWidth: `180px` }}>
        <InputLabel htmlFor="preset-themes" ref={inputLabel}>
          Theme
        </InputLabel>
        <Select
          value={theme.name}
          onChange={handleChange}
          labelWidth={labelWidth}
          inputProps={{
            name: 'theme name',
            id: 'preset-themes',
          }}
        >
          <MenuItem key="light" value="light">
            BetGenius - Light
          </MenuItem>
          {Object.keys(brands).map(key => (
            <MenuItem key={key} value={key}>
              {brands[key].name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

ThemePresets.propTypes = {
  theme: PropTypes.object,
  setTheme: PropTypes.func,
}

export default ThemePresets
